import { render } from "./StaticSpinner.vue?vue&type=template&id=0bbfaa02&ts=true"
import script from "./StaticSpinner.vue?vue&type=script&lang=ts"
export * from "./StaticSpinner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__